// extracted by mini-css-extract-plugin
export default {"gallery":"tgcgh","slide":"atqh6"};